const BadgesSkeleton = () => {
    // Create an array of 3 groups to mimic the grouped badges
    const skeletonGroups = [ 1, 2, 3 ];

    // Create an array of 3 badges per group
    const skeletonBadges = [ 1, 2, 3 ];

    return (
        <div className="dokan-layout bg-white px-8 py-6 rounded shadow-md">
            <div>
                { skeletonGroups.map( ( group ) => (
                    <div key={ group } className="mb-12">
                        <div className="relative mb-8">
                            { /* Group title skeleton */ }
                            <div className={ `grid gap-2` }>
                                <div className="h-2 w-48 bg-gray-200 animate-pulse rounded"></div>
                                <div className="h-2 w-48 bg-gray-200 animate-pulse rounded mb-4"></div>
                            </div>
                            <div className="w-full h-px bg-gray-200 relative">
                                <div className="absolute left-0 top-0 h-px transition-all duration-300 ease-in-out w-16 hover:w-32"></div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                            { skeletonBadges.map( ( badge ) => (
                                <div
                                    className="flex items-center space-x-3"
                                    key={ badge }
                                >
                                    <div className="relative">
                                        { /* Badge logo skeleton */ }
                                        <div className="w-10 h-10 bg-gray-200 animate-pulse rounded-full"></div>
                                    </div>
                                    <div className="flex-1 min-w-0 grid gap-2">
                                        { /* Badge name skeleton */ }
                                        <div className="h-2 bg-gray-200 animate-pulse rounded w-3/4"></div>
                                        <div className="h-2 bg-gray-200 animate-pulse rounded w-3/4"></div>
                                    </div>
                                </div>
                            ) ) }
                        </div>
                    </div>
                ) ) }
            </div>
        </div>
    );
};

export default BadgesSkeleton;
